<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('step_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-book</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-step-show">
      <template v-if="hasVideo">
        
        <div class="d-flex justify-center ma-2">
          <video playsinline autoplay muted loop >
          <source v-if="imageurlItem" :src="imageurlItem" :key="componentKey" type="video/webm">
          Your browser does not support the video tag.
          <track kind="captions" label="French" :src="subtitleBlobfr"  srclang="fr" default v-if="language == 'fr'"/>
          <track kind="captions" label="English" :src="subtitleBloben"  srclang="en" default v-else/>
        </video>
        </div>

        <div class="d-flex justify-space-between align-center flex-column flex-sm-row ma-2">
          <ImageForm
            ref="updateForm"
            :btnabsolute=false
            :video=true
            :item="item"
            v-if="userHasAccess('step_edit')"
          />
          <v-btn
            color="secondary"
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
        </div>
      </template>

      <v-img
        v-else
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          :video=true
          v-if="userHasAccess('step_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                                    {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.number') }}</strong></td>
              <td>
                {{ item['number'] }}
              </td>
              <td></td>
              <td>
  
              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('global.description') }}</strong></td>
              <td class="tablehtmleditor" v-html="item['description']">
              </td>
              <td><strong>{{ $t('global.descriptionfr') }}</strong></td>
              <td class="tablehtmleditor" v-html="item['descriptionfr']">
            
              </td>
            </tr>
            <tr><h2>{{ $t('global.controlsettings') }}</h2></tr>
            <tr>
              <td><strong>{{ $t('macro.macrotype') }}</strong></td>
              <td>
                <span v-if="item['action']">{{ item['action'].name }}</span>
              </td>
              <td><strong>{{ $t('process.moduleref') }}</strong></td>
              <td>
                {{ item['moduleRef'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.tempprogress') }}</strong></td>
              <td>
                {{ item['tempProgress'] }}
              </td>
              <td><strong>{{ $t('process.validator') }}</strong></td>
              <td>
                {{ item['validatorRef'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.actionref') }}</strong></td>
              <td>
                {{ item['actionRef'] }}
              </td>
              <td></td>
              <td>

              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.movementpanel') }}</strong></td>
              <td>
                {{ item['movementPanel'] }}
              </td>
              <td><strong>{{ $t('process.logpanel') }}</strong></td>
              <td>
                {{ item['logPanel'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.doorOpen') }}</strong></td>
              <td class="tablehtmleditor" v-html="item['doorOpen']">
              </td>
              <td><strong>{{ $t('process.withoutModuleOnly') }}</strong></td>
              <td class="tablehtmleditor" v-html="item['withoutModuleOnly']">
            
              </td>
            </tr>
            <tr >
              <td><strong>{{ $t('process.fields') }}</strong></td>
              <td>
                <ul v-for="(object, attr) in item['fields']" :key="attr">
                  <li>
                    <span>{{ $t('global.reference') }} :</span>{{ object['ref'] }} <span>{{ $t('global.name') }} :</span>{{ object['name'] }} <span>{{ $t('global.namefr') }} :</span>{{ object['namefr'] }} <span>{{ $t('global.type') }} :</span>{{ object['type'] }}
                  </li>
                </ul>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';

const servicePrefix = 'Step';

export default {
  name: 'StepShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm
  },
  data() {
    return {
    };
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('step', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('step', ['find']),
    language() {
      return i18n.locale;
    },
    filter() {
      if(this.item['image']) {
        return "";
      }
      if(this.item['image'].filePath) {
        return "";
      }
      if (this.hasVideo) {
        return "";
      } else {
        return '250x250';
      }
    },
    subtitleBlobfr() {
      var data = new Blob([this.item['subtitlefr']], {type: 'text/plain'});
      return URL.createObjectURL(data);
    },
    subtitleBloben() {
      var data = new Blob([this.item['subtitle']], {type: 'text/plain'});
      return URL.createObjectURL(data);
    }
  },
  methods: {
    ...mapActions('step', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
<style>

video {
  max-width: 100%;
  height: auto;
}


</style>
